export const PUTIO_AUTH_URL = 'https://api.put.io/v2/oauth2/authenticate'
export const PUTIO_CLIENT_ID = '4924'
export const PUTIO_VIDEO_URL = 'https://app.put.io/files/'

export const DEFAULT_FOLDER_KEY = 'putflix-folder'

// tmdb doesn't have a rate limit, so exposing token is fine.
export const TMDB_TOKEN = '0226d6c251ad9cbce59f3400d02d75d4'
export const TMDB_API_BASE = 'https://api.themoviedb.org/3/'
export const TMDB_BACKDROP_BASE = 'https://image.tmdb.org/t/p/w1280'
export const TMDB_POSTER_BASE = 'https://image.tmdb.org/t/p/w185'
export const TMDB_ACTOR_BASE = 'https://image.tmdb.org/t/p/w138_and_h175_face'

export const YOUTUBE_ICON = 'https://www.svgrepo.com/show/13671/youtube.svg'
export const IMDB_ICON = 'https://www.svgrepo.com/show/349409/imdb.svg'